module.exports = __webpack_public_path__ + "static/media/HCMM281.d30e099f.jpg";